import { createSelector } from 'reselect';

export const getsyfQuickScreen = (state) => state.syfQuickScreen || {};

export const selectSyfQuickScreenResponse = createSelector([getsyfQuickScreen], (data) => data);
